import {
  UnorderedListOutlined,
  BarcodeOutlined,
  PercentageOutlined,
  DollarOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  FileTextOutlined,
} from '@ant-design/icons';

export const menuItems = [
  {
    type: 'subMenu',
    title: 'list-prices',
    icon: <UnorderedListOutlined />,
    items: [
      {
        title: 'makers',
        to: '/makers',
      },
      {
        title: 'brands',
        to: '/brands',
      },
      {
        title: 'categories',
        to: '/categories',
      },
    ],
  },
  {
    title: 'search-by-code',
    to: '/search_by_code',
    icon: <BarcodeOutlined />,
  },
  {
    title: 'special-offers',
    to: '/promotions',
    icon: <DollarOutlined />,
    hide: (currentUser) => !currentUser?.show_promotions,
  },
  {
    title: 'list-prices-percentage',
    to: '/list_prices',
    icon: <PercentageOutlined />,
    hide: (currentUser) => !currentUser?.show_list_prices,
  },
  {
    title: 'my-account',
    to: '/my_account',
    icon: <UserOutlined />,
  },
  {
    title: 'prev-orders',
    to: '/my_orders',
    icon: <FileTextOutlined />,
  },
  {
    title: 'cart',
    to: '/cart',
    icon: <ShoppingCartOutlined />,
    /* The one item that carries a count. What is waiting in the cart is the
       only thing in this menu that changes while the client works, and nothing
       said so anywhere but the cart screen itself - so a client who added parts
       on one listing and moved to another had no way to see they were there. */
    countsCartItems: true,
  },
];
